<template>
    <div>
        <loading
            :active.sync="loading"
            :can-cancel="false"
            :is-full-page="true"
            :height="150"
            :width="150"
            :color="'#FFFF00'"
            :background-color="'#000000'"
            :opacity="0.5"
        ></loading>
        <v-container>
            <v-form>

                <v-row>
                    <h2 class="pb-5">{{ this.pageTitle }} <span class="page_title_value">{{ this.payoutctrls.payoutdesc }}</span></h2>
                </v-row>

                <v-row>
                    <div class="pb-5 pl-4">
                        <v-btn 
                            color="warning" 
                            style="width: 100px" 
                            @click="backHandler"> 
                            {{$t('button.back')}}
                        </v-btn>
                    </div>
                </v-row>

                <v-container
                    id="scroll-target"
                    class="custom-form overflow-y-auto px-5"
                >

                    <v-row>
                        <v-col cols="12" sm="8" class="pb-n5">
                            <v-text-field
                                outlined
                                :label="this.$t('payrollprocessrun.payout')"
                                type="text"
                                v-model="payoutctrls.payoutcode"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="8" class="pb-n5 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('columns.description')"
                                type="text"
                                v-model="payoutctrls.payoutdesc"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="2" class="pb-n5 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('reportsparam.year')"
                                type="number"
                                v-model="payoutctrls.pyyear"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2" class="pb-n5 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('reportsparam.month')"
                                type="number"
                                v-model="payoutctrls.pymonth"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-expansion-panels>
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                <v-toolbar-title class="subtitle-2">{{$t('payeeinputprocess.expand')}}</v-toolbar-title>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>

                            <v-row class="pt-4">
                                <v-col cols="12" sm="4" class="pb-n5 mt-n8">
                                    <v-text-field
                                        outlined
                                        :label="this.$t('payrollprocessrun.payoutstartdate')"
                                        type="date"
                                        v-model="payoutctrls.startdate"
                                        readonly
                                        background-color="#ffeab2"
                                        dense
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" class="pb-n5 mt-n8">
                                    <v-text-field
                                        outlined
                                        :label="this.$t('payrollprocessrun.payoutenddate')"
                                        type="date"
                                        v-model="payoutctrls.enddate"
                                        readonly
                                        background-color="#ffeab2"
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="4" class="pb-n5 mt-n8">
                                    <v-text-field
                                        outlined
                                        :label="this.$t('payrollprocessrun.payoutstatus')"
                                        readonly
                                        type="text"
                                        v-model="payoutctrls.pystatusdesc"
                                        dense
                                        background-color="#ffeab2"
                                    ></v-text-field>
                                    <input type="text" hidden v-model="payoutctrls.pystatuscode" />
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="8" class="pb-n5 mt-n8">
                                    <v-text-field
                                        outlined
                                        :label="this.$t('setuppayrolltype.payrolltype')"
                                        type="text"
                                        v-model="payoutctrls.payrolltypedesc"
                                        readonly
                                        background-color="#ffeab2"
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="8" class="pb-n5 mt-n8">
                                    <v-text-field
                                        outlined
                                        :label="this.$t('payrollprocessrun.payrollgroup')"
                                        type="text"
                                        v-model="payoutctrls.grouppdesc"
                                        readonly
                                        background-color="#ffeab2"
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="8" class="pb-n5 mt-n8">
                                    <v-text-field
                                        outlined
                                        :label="this.$t('payrollprocessrun.exchangerate')"
                                        type="text"
                                        v-model="payoutctrls.exchratedesc"
                                        readonly
                                        background-color="#ffeab2"
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="8" class="pb-n5 mt-n8">
                                    <v-text-field
                                        outlined
                                        :label="this.$t('payrollprocessrun.payoutfrequency')"
                                        type="text"
                                        v-model="payoutctrls.salfreqdesc"
                                        readonly
                                        background-color="#ffeab2"
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="8" class="pb-n5 mt-n8">
                                    <v-text-field
                                        outlined
                                        :label="this.$t('payrollprocessrun.payeelist')"
                                        type="text"
                                        v-model="payoutctrls.payeelistdesc"
                                        readonly
                                        background-color="#ffeab2"
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-toolbar
                        color="#ECEFF1" class="mt-8"
                    >
                        <h2 class="pt-3 pb-2" style="letter-spacing:normal;">{{ titleSummary }}</h2>
                        <v-spacer></v-spacer>

                        <button class="gv-btn gv-btn-pdf mr-2" @click="printPDFSummary" title="Export PDF">
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 13h2a2 2 0 0 1 0 4H9v-4z"/><path d="M15 13h1a2 2 0 0 1 0 4h-1"/><line x1="15" y1="17" x2="17" y2="17"/></svg>
                            <span>PDF</span>
                        </button>
                        <button class="gv-btn gv-btn-csv mr-2" @click="getCSVSummary" title="Export CSV">
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>
                            <span>CSV</span>
                        </button>
                        <div class="gv-search mr-3" style="align-self: center;">
                            <svg class="gv-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="11" cy="11" r="8"/>
                                <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                            </svg>
                            <input v-model="search" type="text" placeholder="Search..." class="gv-search-input" />
                        </div>
                    </v-toolbar>

                    <v-row>
                        <v-col class="mt-6 ml-2 mb-n6">
                            <h2 class="pb-5">{{$t('previewexception.netpaytotal')}} :<span class="page_title_value"> {{ this.totalzeronetpay }}</span></h2>
                        </v-col>
                        <v-col class="mt-6 ml-2 mb-n6">
                            <h2 class="pb-5">{{$t('previewexception.netpaylesszero')}} :<span class="page_title_value"> {{ this.totalnetpay }}</span></h2>
                        </v-col>
                        <v-col class="mt-6 ml-2 mb-n6">
                            <h2 class="pb-5"> {{$t('previewpayroll.recordscount')}} :<span class="page_title_value"> {{ this.totalperson }}</span></h2>
                        </v-col>
                    </v-row>
                    

                    <v-row>
                        <v-col col="12" sm="12">
                            <v-data-table
                             hide-default-footer
                                :headers="tabHeaderSummary"
                                class="font-weight-light;text--secondary;"
                                :items="summaryList"
                                :items-per-page="1000"
                                fixed-header
                                multi-sort
                                :sort-by="['code']"
                                :search="search"
                                
                                >
                                <!-- <template v-slot:top> -->
                                    <!-- <v-toolbar color="#ECEFF1" flat>
                                        <v-toolbar-title class="subtitle-1">{{titleSummary}}</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-col cols="1" sm="1" class="ml-n4">
                                            <div style="width: 50%; max-height: 50%" >
                                                <button type="button" class="export-icon-btn export-icon-pdf" @click="printPDFSummary" title="Export PDF"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 13h2a2 2 0 0 1 0 4H9v-4z"/><path d="M15 13h1a2 2 0 0 1 0 4h-1"/><line x1="15" y1="17" x2="17" y2="17"/></svg>PDF</button>
                                            </div>
                                        </v-col>
                                        <v-col cols="1" sm="1" class="ml-n4 mr-n4">
                                            <div style="width: 50%">
                                                <button type="button" class="export-icon-btn export-icon-csv" @click="getCSVSummary" title="Export CSV"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>CSV</button>
                                            </div>
                                        </v-col>
                                    </v-toolbar> -->
                                <!-- </template> -->
                                <!-- <template v-slot:body>
                                        <tbody>
                                            <tr v-for="item in summaryList" :key="item.id">
                                                <td >{{item.staffcode}} </td>
                                                <td @click="goDetailHandler(item.id)">{{item.psnname}} </td>
                                                <td >{{item.grosspay}} </td>
                                                <td >{{item.netpay}} </td>
                                                <td >{{item.pycmdstatusdesc}} </td>
                                                <td >{{item.pycalcstatusdesc}} </td>
                                            </tr>
                                        </tbody>
                                    </template> -->
                                <!-- <template v-slot:items >
                                </template> -->
                                <template v-slot:body="{items}">
                                    <tbody>
                                        <tr v-for="item in items" :key="item.id">
                                            <td @click="goDetailHandler(item.staffid, item.salhdid)">{{item.staffcode}} </td>
                                            <td @click="goDetailHandler(item.staffid, item.salhdid)">{{item.psnname}} </td>
                                            <td>{{ item.grosspay != null ? Number(item.grosspay).toLocaleString('en-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '' }}</td>
                                            <td>{{ item.netpay != null ? Number(item.netpay).toLocaleString('en-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '' }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>

                </v-container>
            </v-form>
        </v-container>
    </div>
</template>

<script>
import moment from 'moment';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
    components: {
        Loading,
    },

    props: {
        parentObject: Object
    },

    data() {
        return {
            publicPath: process.env.BASE_URL,
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                }
            },
            pageTitle: this.$t('previewexception.payrollexceptionpayout'),
            pageTitleValue: '',
            formData: {
                pystatuscode: null
            },
            tabHeaderSummary: [
                { text: this.$t('columns.staffid'), value: 'staffcode', width: '100px', sortable: true},
                { text: this.$t('columns.name'), value: 'psnname', width: '200px', sortable: true },
                { text: this.$t('previewpayroll.grosspay'), value: 'grosspay', sortable: true, width: '100px' },
                { text: this.$t('previewpayroll.netpay'), value: 'netpay', width: '100px', sortable: true},
           ],
            
            tableOpt: {
                itemsPerPage: 10
            },

            data: {
                formData: {
                    poid: this.$route.params.id,
                },
            },

            payoutctrls: {
                allowinput: null,
                enddate: null,
                exchratecode: null,
                exchratedesc: null,
                exchrateid: null,
                grouppbid: null,
                grouppcode: null,
                grouppdesc: null,
                id: null,
                payeelistcode: null,
                payeelistdesc: null,
                payoutcode: null,
                payoutdesc: null,
                payrolltypecode: null,
                payrolltypedesc: null,
                payrolltypeid: null,
                pymonth: null,
                pystatuscode: null,
                pystatusdesc: null,
                pyyear: null,
                rectimestamp: null,
                remark: null,
                salfreqcode: null,
                salfreqdesc: null,
                salfreqid: null,
                ssrel: null,
                startdate: null,
                updatedby: null,
                valvaluecode: null,
                valvaluedesc: null,
                valvalueid: null
            },
            staff: [],
            payoutctrlList: [],
            summaryList: [],
            detailList: [],
            detailItemList: [],
            titleSummary: this.$t('previewpayroll.summary'),
            titleDetail: this.$t('payeeinputprocess.details'),
            
            search: '',
            errMsg: '',

            totalnetpay: 0,
            totalzeronetpay: 0,
            totalperson: 0,

            isErr: false,
            editMode: false,
            loading: false,
        }
    },

    methods: {
        
        loadPayrollPreviewSummary() {
            const vm = this;

            return this.$store.dispatch('post', {
                url: `/payrollexception/summary/${this.$store.getters.userId}`, 
                payload: this.data
                })
            .then(function (res) {
                let payrollpreviewHolder = res.data.rec
                let netpayHolder = []
                let grosspayHolder = []
                let netzeropayHolder = []
                let personHolder = 0

                console.log('payrollexception', payrollpreviewHolder)

                for (let i = 0; i < payrollpreviewHolder.length; i++) {
                   // netpayHolder.push(parseFloat(payrollpreviewHolder[i].netpay))
                    grosspayHolder.push(parseFloat(payrollpreviewHolder[i].grosspay))
                    personHolder++

                    if(payrollpreviewHolder[i].netpay < 0){
                          netpayHolder.push(payrollpreviewHolder[i])
                  
                    }

                    if(payrollpreviewHolder[i].netpay == 0){
                          netzeropayHolder.push(payrollpreviewHolder[i])
                    }
                }

                
                vm.summaryList = payrollpreviewHolder
                vm.totalnetpay = netpayHolder.length
                vm.totalzeronetpay = netzeropayHolder.length
                vm.totalperson = personHolder

                console.log('netzero', netzeropayHolder.lengtth)

            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        loadPayoutListHandler() {
            const vm = this;

            if (this.data.formData.poid) {
                return this.$store.dispatch('get', {
                    url: '/payoutctrl/' + this.data.formData.poid
                })
                .then (res => {

                    vm.payoutctrls = res.data.rec[0]

                    vm.payoutctrls.startdate = moment(vm.payoutctrls.startdate).format('YYYY-MM-DD');
                        
                    vm.payoutctrls.enddate = moment(vm.payoutctrls.enddate).format('YYYY-MM-DD');
                        
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                })
            }
        },

        objectToCSV(data) {
            const csvRows = []

            // get header
            const headers = Object.keys(data[0])
            csvRows.push(headers.join(','))

            // loop over the rows
            for (const row of data) {
                const values = headers.map(header => {
                    const escaped = ('' + row[header]).replace(/"/g, '\\"')
                    return `"${escaped}"`
                })
                csvRows.push(values.join(','))
            }
            return csvRows.join('\n')
        },

        download(data, title) {
            const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: 'text/csv'})
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')

            a.setAttribute('hidden', '')
            a.setAttribute('href', url)
            a.setAttribute('download', title + '.csv')

            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        },

        async getCSVSummary() {
            let itemSummary = this.summaryList

            let dataSummary = []
            
            for (var i = 0; i < itemSummary.length; i++) {
              
                dataSummary.push({
                    [`${this.$t('columns.staffid')}`]: itemSummary[i].staffcode,
                    [`${this.$t('columns.name')}`]: itemSummary[i].psnname,
                    [`${this.$t('previewpayroll.grosspay')}`]: itemSummary[i].grosspay,
                    [`${this.$t('previewpayroll.netpay')}`]: itemSummary[i].netpay
                })
            }


            const csvData = this.objectToCSV(dataSummary)
            this.download(csvData, this.titleSummary)
        },

        printPDFSummary() {
            const doc = new jsPDF({
                orientation: 'landscape'
            })
            let item = this.summaryList

            var head = [                
                { title: this.$t('columns.staffid'), dataKey: 'staffcode' },
                { title: this.$t('columns.name'), dataKey: 'psnname' },
                { title: this.$t('previewpayroll.grosspay'), dataKey: 'grosspay' },
                { title: this.$t('previewpayroll.netpay'), dataKey: 'netpay' }
            ]

            let body = []

            for (var i = 0; i < item.length; i++) {
                body.push({
                    staffcode: item[i].staffcode,
                    psnname: item[i].psnname,
                    grosspay: item[i].grosspay,
                    netpay: item[i].netpay
                })
            }
            doc.text(this.titleSummary, 10, 10)
            doc.autoTable(head, body)
            doc.save(this.titleSummary + '.pdf')
        },

        goDetailHandler(staffid, id) {
            let formData = this.data.formData
            //let param = this.data.parameters
            
            this.$router.push({name: 'payrollexceptiondetail', params: { formData, staffid, id}});
        },
        
        backHandler() {
            this.$router.push({name: 'payrollexceptionfilter'});
        },

    },

    async mounted() {
        this.loading = true;
        try {
            await this.loadPayoutListHandler();
            await this.loadPayrollPreviewSummary();
        } finally {
            this.loading = false;
        }
    }
}
</script>

<style>
.gv-btn { display: inline-flex; align-items: center; gap: 6px; padding: 5px 11px; border-radius: 7px; border: none; font-size: 0.82rem; font-weight: 600; cursor: pointer; transition: all 0.15s; font-family: inherit; }
.gv-btn-csv { background: #ECFDF5; color: #059669; border: 1px solid #A7F3D0; }
.gv-btn-csv:hover { background: #059669; color: #fff; border-color: #059669; }
.gv-btn-pdf { background: #FEF2F2; color: #DC2626; border: 1px solid #FECACA; }
.gv-btn-pdf:hover { background: #DC2626; color: #fff; border-color: #DC2626; }
.gv-search { position: relative; display: inline-flex; align-items: center; }
.gv-search-icon { position: absolute; left: 8px; top: 50%; transform: translateY(-50%); pointer-events: none; }
.gv-search-input { padding: 5px 10px 5px 30px; border: 1.5px solid #E8EDF5; border-radius: 8px; font-size: 0.83rem; font-family: inherit; color: #1E293B; outline: none; width: 220px; background: #fff; }
.gv-search-input:focus { border-color: #4F6BFF; box-shadow: 0 0 0 3px rgba(79,107,255,0.10); }
</style>